require('./bootstrap');
window.Vue = require('vue');

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

window.Sentry = Sentry;

Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
});

Sentry.setTags(sentryTags);

require('./cart');
require('./common');

//lazy image load
import LazyLoad from "vanilla-lazyload";

new LazyLoad({
    elements_selector: ".lazyload"
});
